import moment from "moment";
import React from "react";
import trybzLogo from "../../../../../../../assets/logo.png";
import { Link, useParams } from "react-router-dom";
import ParagraphSectionComp from "./components/ParagraphSectionComp";
import { history } from "../../../../../../..";
import formatCurrency from "../../../../../../../utils/helpers/formatCurrency";

const ParagraphInvoiceTemplate = ({
  invoiceDetails,
  backToInvoiceCreationStep = false,
  isUsedAsStep= false,
}) => {
  const { viewType } = useParams();

  return (
    <section className="container tw-bg-white tw-p-6 md:tw-p-10 lg:tw-p-16">
      <div
        className="tw-space-y-6 tw-text-black"
        style={{ paddingTop: "10px" }}
      >
        <div
          style={{
            alignContent: "center",
            justifyContent: "space-between",
            display: "flex",
            marginBottom: "60px",
          }}
          className="invoice-container"
        >
          <img
            style={{
              width: 130,
              height: 110,
              objectFit: "contain",
              objectPosition: "left",
            }}
            src={trybzLogo}
            alt="trybz_logo"
          />
          <div
            className="tw-font-semibold"
            style={{
              fontSize: "40px",
              placeSelf: "center",

              color: "black",
            }}
          >
            INVOICE
          </div>
        </div>
        <div className="tw-mb-[15px] tw-flex-wrap tw-justify-between tw-space-y-6 md:tw-flex md:tw-space-y-0">
          <div className="  tw-font-medium" style={{ display: "block" }}>
            <h3 className="tw-pb-3 tw-font-semibold tw-text-black">FROM:</h3>
            <div style={{ paddingBottom: "5px" }}>
              {invoiceDetails.issuerName}
            </div>
            <div style={{ paddingBottom: "5px" }}>
              {invoiceDetails.issuerEmail}
            </div>
            <div style={{ paddingBottom: "5px" }}>
              {invoiceDetails.issuerPhone}
            </div>
          </div>

          <div className=" tw-font-medium" style={{ display: "block" }}>
            <h3 className="tw-pb-3  tw-font-semibold tw-text-black">TO:</h3>
            <div style={{ paddingBottom: "5px" }}>
              {invoiceDetails.billerEntityName}
            </div>
            <div style={{ paddingBottom: "5px" }}>
              {invoiceDetails.billerEntityEmail}
            </div>
            <div style={{ paddingBottom: "5px" }}>
              {invoiceDetails.billerEntityPhone}
            </div>
          </div>

          <div
            style={{
              display: "block",
              marginBottom: "20px",
              textAlign: "right",
              color: "black",
            }}
          >
            <div className="  tw-font-medium" style={{ paddingBottom: "10px" }}>
              <div style={{ paddingBottom: "5px" }}>
                INVOICE #: {invoiceDetails.invoiceNumber}
              </div>
              <div style={{ paddingBottom: "5px" }}>
                INVOICE DATE:{" "}
                {moment(invoiceDetails.issuedAt).format("DD MMM YY")}
              </div>
              <div style={{ paddingBottom: "5px" }}>
                DUE DATE: {moment(invoiceDetails.dueDate).format("DD MMM YY")}
              </div>
            </div>
            <p className="tw-mt-12 tw-text-lg tw-font-semibold">AMOUNT DUE:</p>
            <p className="tw-text-4xl tw-font-semibold">
              {formatCurrency(invoiceDetails.amount)}
            </p>
          </div>
        </div>
        {/* template type content */}
        <ParagraphSectionComp invoiceDetails={invoiceDetails} />
        <div style={{ paddingBottom: "20px" }} className="bottom">
          {/* NOTES */}
          <div style={{ paddingTop: "30px", display: "block", color: "black" }}>
            <h3
              className=" tw-font-semibold tw-text-black"
              style={{ fontSize: "large" }}
            >
              NOTES:
            </h3>
            <ul>
              <li style={{ paddingBottom: "5px" }}>
                if payment is not received by
                {" " + moment(invoiceDetails.dueDate).format("L")}, this invoice
                is no longer valid. Kindly reach out for a re-issue
              </li>
              <li
                className={
                  !Boolean(invoiceDetails?.discounts?.length) && "tw-hidden"
                }
                style={{ paddingBottom: "5px" }}
              >
                If payment is not received by [discount validity date] any
                specified discounts will no longer apply.
              </li>
              <li style={{ paddingBottom: "5px" }}>
                If payment is not received by [late payment date], an additional
                fee of [X amount /%] will apply
              </li>
            </ul>
          </div>

          <div className="invoice-container" style={{ paddingTop: "20px" }}>
            <div>
              <div className="tw-font-semibold">ISSUED BY:</div>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "24px",
                  paddingTop: "5px",
                }}
              >
                {invoiceDetails.issuerName}
              </div>
            </div>
            {/* Pay button */}
            {invoiceDetails.status === "Pending" && viewType !== "preview" && (
              <div>
                <Link
                  to={`/payment/processing/outgoing/pay-invoice/invoice/${invoiceDetails.id}`}
                  style={{
                    justifySelf: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "20px",
                    color: "white",
                    justifyItems: "center",
                    textDecoration: "none",
                    backgroundColor: "blue",
                    width: "100px",
                    display: "flex",
                    height: "40px",
                  }}
                  className="cursor-pointer"
                >
                  Pay
                </Link>
              </div>
            )}
            {viewType === "preview" && (
              <div>
                <button
                  onClick={() => history.goBack()}
                  style={{
                    justifySelf: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "20px",
                    color: "white",
                    justifyItems: "center",
                    textDecoration: "none",
                    backgroundColor: "blue",
                    width: "100px",
                    display: "flex",
                    height: "40px",
                  }}
                  className="cursor-pointer"
                >
                  Back
                </button>
              </div>
            )}
            {isUsedAsStep && (
              <div>
                <button
                  onClick={() => backToInvoiceCreationStep()}
                  style={{
                    justifySelf: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "20px",
                    color: "white",
                    justifyItems: "center",
                    textDecoration: "none",
                    backgroundColor: "blue",
                    width: "100px",
                    display: "flex",
                    height: "40px",
                  }}
                  className="cursor-pointer"
                >
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParagraphInvoiceTemplate;
